import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function GetStarted() {
  return <section data-section-id="77032" id="calltoaction-banner" className="w-full bg-gradient-to-br from-accent via-background to-secondary/40 py-[100px]">
      <div className="container mx-auto px-4 flex flex-col items-center justify-center text-center">
        <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-4 tracking-tight">
          Need a quick answer?
        </h2>
        <p className="text-foreground/80 mb-8 max-w-2xl text-lg md:text-xl leading-relaxed">
          Call us directly at 0466 880 255 for a free estimate. Our local team is ready to help you maximize your solar efficiency today.
        </p>
        <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-300 shadow-xl shadow-primary/20 rounded-full px-10 py-8 text-base md:text-lg font-bold border-none">
          <Link to="/ContactUsPage">
            Call 0466 880 255
          </Link>
        </Button>
      </div>
    </section>;
}